// League types derived from generated OpenAPI spec
// Note: Most league endpoints return empty content in current OpenAPI spec
// Manual types added based on actual API responses
export let TournamentTypeEnum;
(function (TournamentTypeEnum) {
    TournamentTypeEnum["WEEKLY"] = "WEEKLY";
    TournamentTypeEnum["MONTHLY"] = "MONTHLY";
    TournamentTypeEnum["SEASON"] = "SEASON";
})(TournamentTypeEnum || (TournamentTypeEnum = {}));
